import ManagerWorkplaceEdit from '../ManagerWorkplaceEdit/ManagerWorkplaceEdit';
import ManagerWorkplaceDelete from '../ManagerWorkplaceDelete/ManagerWorkplaceDelete';
import React from 'react';
import { WorkplacesTreeItem } from '../ManagerWorkplaceWrapper/ManagerWorkplaceWrapper';

interface Props {
	isEditModalOpen: boolean;
	setIsEditModalOpen: (isOpen: boolean) => void;
	isDeleteModalOpen: boolean;
	setIsDeleteModalOpen: (isOpen: boolean) => void;
	item: WorkplacesTreeItem;
	onChange: () => void;
}

const ManagerWorkplaceModals = ({
	isEditModalOpen,
	setIsEditModalOpen,
	isDeleteModalOpen,
	setIsDeleteModalOpen,
	item,
	onChange,
}: Props) => {
	const handleEditOnChange = () => {
		setIsEditModalOpen(false);
		onChange();
	};

	const handleDeleteOnChange = () => {
		setIsDeleteModalOpen(false);
		onChange();
	};

	return (
		<>
			{isEditModalOpen && (
				<ManagerWorkplaceEdit
					isOpen={isEditModalOpen}
					onClose={() => setIsEditModalOpen(false)}
					item={item}
					onChange={handleEditOnChange}
				/>
			)}
			{isDeleteModalOpen && (
				<ManagerWorkplaceDelete
					isOpen={isDeleteModalOpen}
					onClose={() => setIsDeleteModalOpen(false)}
					item={item}
					onChange={handleDeleteOnChange}
				/>
			)}
		</>
	);
};

export default ManagerWorkplaceModals;
